import React from 'react';
import classnames from 'classnames';

import './WpModalBody.scss';

type Padding = 0 | 1;
const DEFAULT_PADDING = 1;

export interface Props {
  children?: React.ReactNode;
  size?: string;
  padding?: Padding;
}

const WpModalBody: React.FC<Props> = ({ children, size, padding = DEFAULT_PADDING }: Props) => {
  const classNamePrefix = 'WpModalBody';

  const classes = classnames(classNamePrefix, `${classNamePrefix}--${size}`, `${classNamePrefix}--padding-${padding}`);
  return <div className={classes}>{children}</div>;
};

export default WpModalBody;
